/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Task_Assigned_Documents_HeadingInputs */

const en_email_task_assigned_documents_heading = /** @type {(inputs: Email_Task_Assigned_Documents_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested documents`)
};

const pt_br2_email_task_assigned_documents_heading = /** @type {(inputs: Email_Task_Assigned_Documents_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos solicitados`)
};

/**
* | output |
* | --- |
* | "Requested documents" |
*
* @param {Email_Task_Assigned_Documents_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_documents_heading = /** @type {((inputs?: Email_Task_Assigned_Documents_HeadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_Documents_HeadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_documents_heading(inputs)
	return pt_br2_email_task_assigned_documents_heading(inputs)
});